<template>
  <div class="single">
    <myOnlineInvoicing class="aa"></myOnlineInvoicing>
  </div>
</template>
<script>
import OnlineInvoicing from './OnlineInvoicing'
export default {
  data() {
    return {}
  },
  created() {
  if(this.$route.params.order=='2'){
      this.$store.commit('singl','2')
      this.$store.commit('Ord_Nu',this.$route.params.Ord_Num)
  }else if(this.$route.params.order=='1'){
      this.$store.commit('singl','1')
  }else{ this.$router.push({path:"/orderManagement"})}
  },
  components: {
    myOnlineInvoicing: OnlineInvoicing
  }
}
</script>
<style lang="scss" scoped>
.single {
  .aa{
      padding-bottom: 3rem;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/view/home/single.vue